import { useCallback, useEffect } from "react";
import { connect } from "react-redux";
import Section from "../../common/section";
import {
  learningProgramCountSummaryRequest,
  learningProgramItemSummaryRequest,
  learningProgramUsersRequest,
  setLearningProgramQuery,
  learningProgramUserExcelRequest,
} from "../../../store/slices/selfSlice";
import LearningStatusSummary from "./widgets/LearningStatusSummary";
import LearningItemSummary from "./widgets/LearningItemSummary";
import LearningUsersSummary from "./widgets/LearningUsersSummary";
import { Button } from "primereact/button";
import DropdownButton from "../../common/dropDownButton";
import { useIntl } from "react-intl";

const LearningProgramReport = ({
  filters = [],
  additionalQuery = {},
  learningPrograms,
  loadLearningProgramCountSummary,
  loadLearningProgramItemSummary,
  loadLearningProgramUsers,
  setLearningProgramQuery,
  loadLearningProgramUserExcel,
}) => {
  const intl = useIntl();

  const fetchReports = useCallback(() => {
    const payloadFilters = [];

    loadLearningProgramCountSummary({
      query: additionalQuery,
      filters: payloadFilters,
    });
    loadLearningProgramItemSummary({
      query: additionalQuery,
      filters: payloadFilters,
    });
  }, [
    loadLearningProgramCountSummary,
    loadLearningProgramItemSummary,
    setLearningProgramQuery,
    additionalQuery,
  ]);

  const fetchUserList = useCallback(() => {
    const payloadFilters = [];
    loadLearningProgramUsers({
      query: {
        ...learningPrograms.query,
        ...additionalQuery,
      },
      filters: payloadFilters,
    });
  }, [learningPrograms.query, additionalQuery]);

  useEffect(() => {
    fetchReports();
  }, [fetchReports]);

  useEffect(() => {
    fetchUserList();
  }, [fetchUserList]);

  const exportReport = (fileType = "excel") => {
    loadLearningProgramUserExcel({
      fileType,
      query: {
        ...learningPrograms.query,
        ...additionalQuery,
      },
      filters: filters
        .filter((item) => item.values.length > 0)
        .map((item) => ({
          id: item.id,
          values: item.values,
          isDynamicField:
            item.id !== "Designation" &&
            item.id !== "Department" &&
            item.id !== "ManagerId",
        })),
    });
  };

  return (
    <div className="grid">
      <div className="col-12 md:col-4">
        <Section title="summary">
          <LearningStatusSummary
            loading={learningPrograms?.countSummary === null}
            data={learningPrograms?.countSummary || []}
          />
        </Section>
      </div>
      <div className="col-12 md:col-8">
        <Section title="by_learning_Programs">
          <LearningItemSummary
            loading={learningPrograms?.itemSummary === null}
            data={learningPrograms?.itemSummary || []}
          />
        </Section>
      </div>
      <div className="col-12">
        <Section title="details">
          <div
            className="flex justify-content-end"
            style={{ marginBottom: 10 }}
          >
            <DropdownButton
              icon="pi pi-download"
              label={intl.formatMessage({ id: "export" })}
              items={[
                {
                  label: intl.formatMessage({ id: "excel" }),
                  command: () => exportReport("excel"),
                },
                {
                  label: intl.formatMessage({ id: "csv" }),
                  command: () => exportReport("csv"),
                },
                {
                  label: intl.formatMessage({ id: "pdf" }),
                  command: () => exportReport("pdf"),
                },
              ]}
            />
          </div>
          <LearningUsersSummary
            loading={learningPrograms?.list?.list === null}
            data={learningPrograms?.list?.list || []}
            totalRecords={learningPrograms?.list?.totalCount || 0}
            query={learningPrograms.query || {}}
            setQuery={setLearningProgramQuery}
          />
        </Section>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  learningPrograms: state.self?.myteam?.learningPrograms || {},
});

const mapDispatchToProps = (dispatch) => ({
  loadLearningProgramCountSummary: (data) =>
    dispatch(learningProgramCountSummaryRequest(data)),
  loadLearningProgramItemSummary: (data) =>
    dispatch(learningProgramItemSummaryRequest(data)),
  loadLearningProgramUsers: (data) =>
    dispatch(learningProgramUsersRequest(data)),
  setLearningProgramQuery: (data) => dispatch(setLearningProgramQuery(data)),
  loadLearningProgramUserExcel: (data) =>
    dispatch(learningProgramUserExcelRequest(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningProgramReport);
